import { render, staticRenderFns } from "./alarm-detail-im.vue?vue&type=template&id=36ecabb8&scoped=true"
import script from "./alarm-detail-im.vue?vue&type=script&lang=js"
export * from "./alarm-detail-im.vue?vue&type=script&lang=js"
import style0 from "./alarm-detail-im.vue?vue&type=style&index=0&id=36ecabb8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ecabb8",
  null
  
)

export default component.exports